import { defineMessages } from 'react-intl';

const messages = defineMessages({
  addRentSchedule: {
    id: 'App.Commercial.Rent.EditRentModal.AddRentSchedule',
    defaultMessage: 'Add Rent Schedule',
  },
  cancel: {
    id: 'App.Commercial.Rent.EditRentModal.Cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'App.Commercial.Rent.EditRentModal.Save',
    defaultMessage: 'Save',
  },
  monthlyAmountLabel: {
    id: 'App.Commercial.Rent.EditRentModal.MonthlyAmountLabel',
    defaultMessage: 'Monthly Amount *',
  },
  notesLabel: {
    id: 'App.Commercial.Rent.EditRentModal.NotesLabel',
    defaultMessage: 'Notes',
  },
  notesPlaceholder: {
    id: 'App.Commercial.Rent.EditRentModal.NotesPlaceholder',
    defaultMessage: 'Enter Note',
  },
  startDateLabel: {
    id: 'App.Commercial.Rent.EditRentModal.StartDateLabel',
    defaultMessage: 'Start Date *',
  },
  holdoverLabel: {
    id: 'App.Commercial.Rent.EditRentModal.HoldoverLabel',
    defaultMessage: 'Holdover: *',
  },
  noIncrease: {
    id: 'App.Commercial.Rent.EditRentModal.NoIncrease',
    defaultMessage: 'No Increase',
  },
  addRent: {
    id: 'App.CommercialLeaseDataTab.Rent.EditRentModal.AddRent',
    defaultMessage: 'Add Rent',
  },
  editRentSchedule: {
    id: 'App.Commercial.Rent.EditRentModal.EditRentSchedule',
    defaultMessage: 'Edit Rent Schedule',
  },
});

export default messages;
